/* eslint-disable  import/no-cycle -- need */
import uuid from 'react-uuid';
import {
  getCallRequestOptions, normalizeAndDecode, postCallRequestOptions,
  getMetaData, encodeToBase64, encryptPayload,
  stringifyObjectValues,
  combineDataFields, getCurrentPage,
} from './util';
import { performOperations } from '../Operations/Operations';

const getVal = require('lodash/get');

export const fetchS3Data = async (paramsObj, type = 'passcode', isV2 = false) => {
  // methods should know --> base url, pageType, cuid, docId, requestPayload
  const requestOptions = {
    method: 'POST',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
      journeyId: paramsObj.journeyId,
      traceId: paramsObj.traceId,
    },
    body: encryptPayload(paramsObj.requestPayload),
  };
  const response = await fetch(
    `${paramsObj.iformIntegrationUrls}/iForms/${paramsObj.pageType}${isV2 ? '/v2' : ''}/s3/retrieve/${type}?cuid=${paramsObj.cuid}&page=${getCurrentPage()}`,
    requestOptions
  );
  return response;
};

export const saveDataToS3 = async (paramsObj, isV2 = false) => {
  const requestOptions = {
    method: 'POST',
    credentials: 'include',
    headers: {
      journeyId: paramsObj.journeyId,
      traceId: paramsObj.traceId,
    },
    body: paramsObj.formData,
  };
  const response = await fetch(
    `${paramsObj.iformIntegrationUrls}/iForms/${paramsObj.pageType}${isV2 ? '/v2' : ''}/s3/upload?cuid=${paramsObj.cuid}&page=${getCurrentPage()}`,
    requestOptions
  );
  const result = await response.json();
  return result;
};

export const deleteFileFromS3 = async (paramsObj) => {
  const requestOptions = {
    method: 'DELETE',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
      journeyId: paramsObj.journeyId,
    },
  };
  const response = await fetch(
    `${paramsObj.iformIntegrationUrls}/iForms/${paramsObj.pageType}/s3/delete?cuid=${paramsObj.cuid}&page=${getCurrentPage()}&docKey=${paramsObj.fileId}`,
    requestOptions
  );
  return response;
};

export const checkReviewPortalStatus = async (paramsObj) => {
  const requestOptions = getCallRequestOptions(paramsObj.journeyId);
  const request = `${paramsObj.iformIntegrationUrls}/iForms/${paramsObj.pageType}/v2/reviewEnabled?cuid=${paramsObj.cuid}&page=${getCurrentPage()}`;
  const response = await fetch(`${request}`, requestOptions);
  const result = await response.json();
  if (result && result.statusIndicator === 'T') {
    return result.data === 'true';
  }
  return false;
};

/* eslint-disable max-params -- need */
export const sequenceIDApi = async (memberApiUrls, jId, cuid, format) => {
  const requestOptions = {

    method: 'GET',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
      traceId: uuid(),
      journeyId: jId,
      Format: format,
    },
  };
  const sequenceIDResponse = `${memberApiUrls}/iForms/unsecure/utility/idGenerator/SponsorID?cuid=${cuid}&page=${getCurrentPage()}`;
  const response = await fetch(`${sequenceIDResponse}`, requestOptions);
  const result = await response.json();
  if (result && result.statusIndicator === 'T') {
    return result.data;
  }
  return null;
};
/* eslint-enable max-params -- need */

export const fetchESignPdf = async (paramsObj) => {
  const requestOptions = {
    defer: true,
    method: 'POST',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
    },
    body: encryptPayload(paramsObj.requestPayload),
  };
  const data = await fetch(
    `${paramsObj.iformIntegrationUrls}/iForms/${paramsObj.pageType}/pdf/generator?cuid=${paramsObj.cuid}&page=${getCurrentPage()}`,
    requestOptions
  );
  return data;
};

export const generateEsignPdfAndUpload = async (paramsObj) => {
  const requestOptions = {
    defer: true,
    method: 'POST',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
    },
    body: encryptPayload(paramsObj.requestPayload),
  };
  const data = await fetch(
    `${paramsObj.iformIntegrationUrls}/iForms/${paramsObj.pageType}/v2/pdf/generatePDFAndUploadToS3?cuid=${paramsObj.cuid}&page=${getCurrentPage()}`,
    requestOptions
  );
  return data;
};

export const validateStatusOnWhatsapp = async (paramsObj) => {
  const requestOptions = {
    method: 'POST',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
    },
    body: encryptPayload(paramsObj.requestPayload),
  };
  const response = await fetch(
    `${paramsObj.iformIntegrationUrls}/iForms/${paramsObj.pageType}/whatsapp/updateUserStatus?cuid=${paramsObj.cuid}`,
    requestOptions
  );
  return response;
};

export const responseBuilder = async (url, requestOptions) => {
  try {
    const response = await fetch(url, requestOptions);
    const result = await response.json();
    if (response.ok) {
      const standardResponse = {
        status: result.statusCode || response.status,
        statusIndicator: result.statusIndicator || 'T',
        message: result.message || 'Request successful',
      };
      // if result contains data then add the same field to standar response
      // else add the data field to standard response
      if (result.data) {
        standardResponse.data = result.data;
      } else {
        delete result.statusCode;
        delete result.statusIndicator;
        delete result.message;
        standardResponse.data = {
          ...result,
        };
      }
      return standardResponse;
    }
    return {
      status: response.status,
      statusIndicator: 'F',
      message: result?.message || response.statusText,
      data: null,
    };
  } catch (error) {
    // Handle network or runtime errors
    // console.error("Error during API call:", error);
    return {
      status: 500,
      statusIndicator: 'F',
      message:
        `An error occurred while making the API call -- ${error.message}`,
      data: null,
    };
  }
};

export const getMemberEmail = async (props) => {
  const {
    iformIntegrationUrls,
    memberInfo,
    journeyId,
    cuid,
  } = props.dataObject;
  const { loggerApiCall } = props.functionObject;
  const requestOptions = getCallRequestOptions(journeyId);
  const emailApi = `${iformIntegrationUrls}/iForms/secure/member/${memberInfo.accountToken}/email?cuid=${cuid}&page=${getCurrentPage()}`;
  const res = await responseBuilder(emailApi, requestOptions); // calls and handles the api
  if (res.statusIndicator === 'T') {
    loggerApiCall('status=getMemberEmailApiCallSuccess', 'info');
  } else if (res.statusIndicator === 'F') {
    loggerApiCall(`status=getMemberEmailApiCallFailed with statusCode=${res.status} message=${res.message}`, 'error');
  }
  return res;
};

export const lookupData = async (props) => {
  const {
    dataObject,
    callType,
    apiCallerId,
  } = props;
  const {
    setFormSubmissionPayload,
    loggerApiCall,
  } = props.functionObject;
  const {
    formContainer,
    journeyId,
    cuid,
    iformIntegrationUrls,
  } = dataObject;

  const lookupType = formContainer.operations?.[apiCallerId]?.type;
  const addDataAs = formContainer.operations?.[apiCallerId]?.addDataAs || 'lookupData';
  const onSuccessNavigate = formContainer.operations?.[apiCallerId]?.onSuccessNavigate;
  const onFailNavigate = formContainer.operations?.[apiCallerId]?.onFailNavigate;

  loggerApiCall(`status=${lookupType}LookupApiCalled for caller -- ${apiCallerId}`, 'info');
  setFormSubmissionPayload((prevPayload) => ({
    ...prevPayload,
    [`${apiCallerId}Status`]: 'inProgress',
    elemId: null,
  }));
  const requestKeys = formContainer?.operations?.[apiCallerId]?.requestKeys || {};
  const requestPayload = getMetaData(requestKeys, dataObject);
  const requestOptions = postCallRequestOptions(journeyId, requestPayload);
  const res = await responseBuilder(`${iformIntegrationUrls}/iForms/${formContainer.pageType}/lookUp/${lookupType}?cuid=${cuid}&page=${getCurrentPage()}`, requestOptions);
  if (callType === 'standAlone') {
    if (res.statusIndicator === 'T') {
      if (res.status === 206) {
        // call is successfull but no data found
        loggerApiCall(`status=${lookupType}LookupApiCallSuccess for caller -- ${apiCallerId} - No Data Found`, 'info');
        setFormSubmissionPayload((prevPayload) => ({
          ...prevPayload,
          [addDataAs]: null,
          [`${apiCallerId}Status`]: 'noData',
          elemId: null,
        }));
      } else {
        loggerApiCall(`status=${lookupType}LookupApiCallCallSuccess for caller -- ${apiCallerId}`, 'info');
        // if we have to perform custom operations on success-->
        if (formContainer.operations?.[apiCallerId]?.onSuccessOperations?.length > 0) {
          performOperations({
            ...props,
            operations: formContainer.operations[apiCallerId].onSuccessOperations,
            dataObject: {
              ...dataObject,
              [addDataAs]: res.data.lookUpData,
            },
          });
        }
        setFormSubmissionPayload((prevPayload) => ({
          ...prevPayload,
          [addDataAs]: res.data.lookUpData,
          [`${apiCallerId}Status`]: 'success',
          elemId: onSuccessNavigate,
        }));
      }
    } else {
      loggerApiCall(`status=${lookupType}LookupApiCallFailed with statusCode=${res.status} for caller -- ${apiCallerId} message=${res.message}`, 'error');
      setFormSubmissionPayload((prevPayload) => {
        delete prevPayload[addDataAs];
        return {
          ...prevPayload,
          [`${apiCallerId}Status`]: 'failed',
          elemId: onFailNavigate,
        };
      });
    }
  } else {
    return res;
  }
  return null;
};

export const handleDecryptApi = async ({
  decryptParams,
  params,
  memberApiUrls,
  jId,
  cuid,
}) => {
  // need to generate lookup payload
  const payloadParams = {};
  decryptParams.forEach((key) => {
    payloadParams[key] = normalizeAndDecode(params[key]);
  });
  const requestOptions = postCallRequestOptions(jId, payloadParams);
  const decryptApi = `${memberApiUrls}/iForms/secure/hiped/decryption?cuid=${cuid}&page=${getCurrentPage()}`;
  return responseBuilder(decryptApi, requestOptions);
};

export const finsTransactions = async (props) => {
  const {
    dataObject,
    callType,
  } = props;
  const {
    setFormSubmissionPayload,
    loggerApiCall,
  } = props.functionObject;
  const {
    formContainer,
    journeyId,
    cuid,
    iformIntegrationUrls,
  } = dataObject;

  // delete previous fins response and update state
  setFormSubmissionPayload((prevPayload) => {
    delete prevPayload.finsTransactions;
    return {
      ...prevPayload,
      finsTransactionsStatus: 'inProgress',
      elemId: null,
    };
  });

  let onSuccessNavigate = null;
  if (formContainer.operations?.finsTransactions
    && Object.keys(formContainer.operations.finsTransactions)
      .includes('onSuccessNavigate')) {
    onSuccessNavigate = formContainer.operations.finsTransactions.onSuccessNavigate;
  }
  let onFailNavigate = 'error';
  if (formContainer.operations?.finsTransactions
    && Object.keys(formContainer.operations.finsTransactions)
      .includes('onFailNavigate')) {
    onFailNavigate = formContainer.operations.finsTransactions.onFailNavigate;
  }
  /*
  Request payload
  const requestKeys = {
    accountToken: '', --> mandatory
    type: 'DEBIT'/'CREDIT',
    "cycleIndex": 1,
    "merchantId": "",
    "amountGreaterOrEqual": 100,
    "amountGreater": 5000,
    "amountEqual": 100,
    "amountLess": 100,
    "amountLessOrEqual": 100,
    "customFilter": true --> if we are sending filters like amountGreater, amountLess etc
  };
  */

  const requestKeys = formContainer?.operations?.finsTransactions?.requestKeys || { accountToken: 'memberInfo.accountToken' };
  const requestPayload = getMetaData(requestKeys, dataObject);
  const requestOptions = postCallRequestOptions(journeyId, requestPayload);
  const finsTransactionApi = `${iformIntegrationUrls}/iForms/secure/fins/transactions?cuid=${cuid}&page=${getCurrentPage()}`;
  const res = await responseBuilder(finsTransactionApi, requestOptions);
  if (callType === 'standAlone') {
    if (res.statusIndicator === 'T') {
      loggerApiCall('status=finsTransactionsApiCallSuccess', 'info');
      setFormSubmissionPayload((prevPayload) => ({
        ...prevPayload,
        finsTransactions: res.data,
        finsTransactionsStatus: 'success',
        elemId: onSuccessNavigate,
      }));
    } else {
      loggerApiCall(`status=finsTransactionsApiCallFailed with statusCode=${res.status} message=${res.message}`, 'error');
      setFormSubmissionPayload((prevPayload) => ({
        ...prevPayload,
        finsTransactionsStatus: 'failed',
        elemId: onFailNavigate,
      }));
    }
  } else {
    if (res.statusIndicator === 'T') {
      loggerApiCall('status=finsTransactionsApiCallSuccess', 'info');
    } else if (res.statusIndicator === 'F') {
      loggerApiCall(`status=finsTransactionsApiCallFailed with statusCode=${res.status} message=${res.message}`, 'error');
    }
    return res;
  }
  return null;
};

export const creditStatus = async (props) => {
  const {
    callType,
    dataObject,
  } = props;
  const {
    iformIntegrationUrls,
    journeyId,
    formContainer,
    cuid,
    memberInfo,
  } = dataObject;

  const requestOptions = getCallRequestOptions(journeyId);
  const res = await responseBuilder(
    `${iformIntegrationUrls}/iForms/${formContainer.pageType}/css/${memberInfo.accountToken}/getCreditStatus?cuid=${cuid}&page=${getCurrentPage()}`,
    requestOptions);
  if (callType === 'standAlone') {
    // to be implemented based on use case
  } else if (callType === 'parallel') {
    return res;
  }
  return null;
};

export const cardVerify = async (props) => {
  // If apiName = cardVerifySubmit -->
  const {
    callType,
    dataObject,
    apiName,
    apiCallerId = 'cardVerify',
  } = props;
  const {
    formSubmissionPayload,
    memberInfo,
    iformIntegrationUrls,
    formContainer,
    cuid,
    journeyId,
  } = dataObject;
  const {
    loggerApiCall,
    setFormSubmissionPayload,
  } = props.functionObject;
  loggerApiCall(`status=calledCardVerifyApi endpoint=${apiCallerId}`, 'info');
  const requestPayload = {
    accountToken: memberInfo?.accountToken,
    cardNumber: formSubmissionPayload.cardNumber,
    cvv: encodeToBase64(formSubmissionPayload.cvv),
  };
  const cardVerifyOperations = formContainer.operations?.[apiCallerId];
  const operationType = cardVerifyOperations?.operationType || 'verifyCvv';
  if (cardVerifyOperations) {
    if (cardVerifyOperations.requestKeys) {
      const {
        combineFields,
        dob,
      } = cardVerifyOperations.requestKeys;
      if (combineFields?.length > 0) {
        combineFields.forEach((fieldObj) => {
          // combineDataFields
          const combinedField = combineDataFields(fieldObj.fieldsToCombine, dataObject);
          if (combinedField !== '') {
            requestPayload[fieldObj.addAs] = combinedField;
          }
        });
      }
      if (dob) {
        const { dobObject } = dob;
        const userDob = getVal(dataObject, dobObject.dobKey);
        const dobValueArray = userDob.split(dobObject.separator);
        requestPayload[dob.addAs] = `${dobValueArray[dobObject.yearIndex]}${dobValueArray[dobObject.monthIndex]}${dobValueArray[dobObject.dayIndex]}`;
      }
    }
  }
  const requestOptions = postCallRequestOptions(journeyId, requestPayload);
  const cardVerifyApi = `${iformIntegrationUrls}/iForms/${formContainer.pageType}/card/verification?cuid=${cuid}&operation=${operationType}&page=${getCurrentPage()}`;
  const res = await responseBuilder(cardVerifyApi, requestOptions);
  const data = {};
  if (res.statusIndicator === 'T') {
    loggerApiCall(`status=cardVerifyApiCallSuccess endpoint=${apiCallerId}`, 'info');
    data.cardVerifyStatus = 1;
  } else if (res.statusIndicator === 'F') {
    loggerApiCall(`status=cardVerifyApiCallFailed with statusCode=${res.status} endpoint=${apiCallerId} message=${res.message}`, 'error');
    data.cardVerifyStatus = 0;
  }
  if (callType === 'standAlone') {
    let onSuccessNavigate = apiName === 'cardVerifySubmit' ? 'submit' : 'continue';
    if (formContainer.operations?.cardVerify?.onSuccessNavigate) {
      onSuccessNavigate = formContainer.operations?.cardVerify?.onSuccessNavigate;
    }
    let onFailNavigate = null;
    if (formContainer.operations?.cardVerify?.onFailNavigate) {
      onFailNavigate = formContainer.operations.cardVerify.onFailNavigate;
    }
    if (res.statusIndicator === 'T') {
      setFormSubmissionPayload(
        { ...formSubmissionPayload, ...{ elemId: onSuccessNavigate, ...data } }
      );
    } else {
      setFormSubmissionPayload(
        { ...formSubmissionPayload, ...{ elemId: onFailNavigate, ...data } });
    }
  } else if (callType === 'parallel') {
    return {
      ...res,
      data,
    };
  }
  return null;
};

export const fetchItrackerStatus = async (props) => {
  const {
    callType,
    dataObject,
  } = props;
  const {
    formSubmissionPayload,
    iTrackerApiBaseUrls,
    formContainer,
    cuid,
    searchType,
  } = dataObject;
  const {
    loggerApiCall,
    handleContinue,
    handleClicApi,
  } = props.functionObject;
  const { itrackerConfig } = formContainer;
  if (itrackerConfig) {
    const {
      searchHeaderList,
      searchValueKeyList,
      clicCaseStatusToMoveToPage,
    } = itrackerConfig;
    if (searchHeaderList && searchValueKeyList) {
      const hashInput = searchHeaderList.map((header, i) => ({
        name: header,
        value: formSubmissionPayload[searchValueKeyList[i]],
      }));

      const logString = 'status=calledFetchItrackerStatus';
      loggerApiCall(logString, 'info');
      const requestPayload = {
        cuid,
        hashInput,
      };
      const requestOptions = {
        method: 'POST',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
        },
        body: encryptPayload(requestPayload),
      };
      const url = `${iTrackerApiBaseUrls}insightTracker/getStatus`;
      const res = await responseBuilder(url, requestOptions);
      if (res.statusIndicator === 'T') {
        loggerApiCall('status=fetchItrackerStatusApiCallSuccess', 'info');
      } else if (res.statusIndicator === 'F') {
        loggerApiCall(`status=fetchItrackerStatusApiCallFailed with statusCode=${res.status} message=${res.message}`, 'error');
      }
      if (callType === 'standAlone') {
        if (res.statusIndicator === 'T') {
          if (res.data.status === '200' && res.data.iformTrack) {
            if (clicCaseStatusToMoveToPage.status.map((val) => val.toUpperCase())
              .includes(res.data.iformTrack.trkStatNm.toUpperCase())) {
              handleContinue(clicCaseStatusToMoveToPage.successPage);
            }
          } else {
            handleClicApi(searchType);
          }
        } else {
          handleContinue(clicCaseStatusToMoveToPage.failurePage);
        }
      }
    } else {
      handleClicApi(searchType);
    }
  } else {
    handleClicApi(searchType);
  }
  return null;
};
/* This method is used to fetch pincode details for IN */
export const getCityStateByPincode = async (props) => {
  const {
    dataObject,
    callType,
    keysToSave = {},
  } = props;
  const {
    setFormSubmissionPayload,
    loggerApiCall,
  } = props.functionObject;
  const {
    journeyId,
    iformIntegrationUrls,
  } = dataObject;

  const requestOptions = getCallRequestOptions(journeyId);
  const cityKey = keysToSave.city || 'city';
  const stateKey = keysToSave.state || 'state';
  const getCityStateByPincodeApi = `${iformIntegrationUrls}/iForms/unsecure/lms-connector/citystatebypincode?addressPincode=${props.value}&page=${getCurrentPage()}`;
  const res = await responseBuilder(getCityStateByPincodeApi, requestOptions);
  if (callType === 'standAlone') {
    if (res.statusIndicator === 'T') {
      loggerApiCall('status=getCityStateByPincodeSucess', 'info');
      setFormSubmissionPayload((prevPayload) => ({
        ...prevPayload,
        [cityKey]: res.data.cityNm,
        [stateKey]: res.data.stateNm,
      })
      );
    } else {
      loggerApiCall(`status=getCityStateByPincodeFailed with statusCode=${res.status} message=${res.message}`, 'error');
    }
  }
};

export const stageOneSubmit = async (props) => {
  const {
    apiCallerId,
    dataObject,
    functionObject,
  } = props;
  const {
    iformIntegrationUrls,
    journeyId,
    formContainer,
  } = dataObject;
  const {
    setFormSubmissionPayload,
    loggerApiCall,
    setIsFormSubmission,
  } = functionObject;
  const onSuccessNavigate = formContainer.operations?.[apiCallerId]?.onSuccessNavigate;

  const requestKeys = formContainer?.operations?.[apiCallerId]?.requestKeys || {};
  const requestPayload = getMetaData(requestKeys, props.dataObject);

  const requestOptions = postCallRequestOptions(journeyId, requestPayload);

  const addDataAs = formContainer.operations?.[apiCallerId]?.addDataAs || 'stage1Data';
  const addStatusAs = formContainer.operations?.[apiCallerId]?.addStatusAs || 'stage1Status';

  const stageApi = `${iformIntegrationUrls}/iForms/unsecure/lms-connector/stage1?page=${getCurrentPage()}`;
  const res = await responseBuilder(stageApi, requestOptions); // calls and handles the api
  if (res.statusIndicator === 'T') {
    setFormSubmissionPayload((prevPayload) => ({
      ...prevPayload,
      [addDataAs]: res.data,
      [addStatusAs]: res.status,
      [`${apiCallerId}Status`]: 'success',
      elemId: onSuccessNavigate,
    }));
  } else {
    loggerApiCall(`status=stage1LookupApiCallFailed with statusCode=${res.status} for caller -- ${apiCallerId} message=${res.message}`, 'error');
    setFormSubmissionPayload((prevPayload) => {
      delete prevPayload[addDataAs];
      return {
        ...prevPayload,
        [`${apiCallerId}Status`]: 'failed',
        [addStatusAs]: res.status,
        message: res.message,
        pcn_number: res.data?.pcn_number || '',
        elemId: 'error',
      };
    });
  }
  setIsFormSubmission(false);
};
export const resumeJourney = async (props) => {
  const {
    apiCallerId,
    dataObject,
    functionObject,
  } = props;
  const {
    iformIntegrationUrls,
    journeyId,
    formContainer,
  } = dataObject;
  const {
    setFormSubmissionPayload,
    loggerApiCall,
  } = functionObject;
  const onSuccessNavigate = formContainer.operations?.[apiCallerId]?.onSuccessNavigate;

  const requestKeys = formContainer?.operations?.[apiCallerId]?.requestKeys || {};
  const requestPayload = getMetaData(requestKeys, props.dataObject);
  const requestOptions = postCallRequestOptions(journeyId, requestPayload);
  const addDataAs = formContainer.operations?.[apiCallerId]?.addDataAs || 'resumeFormData';

  const resumeFormAPI = `${iformIntegrationUrls}/iForms/unsecure/lms-connector/resume-form?page=${getCurrentPage()}`;
  const res = await responseBuilder(resumeFormAPI, requestOptions); // calls and handles the api

  if (res.statusIndicator === 'T') {
    loggerApiCall('status=resumeFlowApiCallSuccess', 'info');
    setFormSubmissionPayload((prevPayload) => ({
      ...prevPayload,
      [addDataAs]: res.data,
      firstName: res.data.first_name,
      lastName: res.data.last_name,
      ...res.data,
      [`${apiCallerId}Status`]: 'success',
      elemId: onSuccessNavigate,
    }));
  } else {
    loggerApiCall(`status=resumeFlowApiCallFailed with statusCode=${res.status} for caller -- ${apiCallerId} message=${res.message}`, 'error');
    setFormSubmissionPayload((prevPayload) => {
      delete prevPayload[addDataAs];
      return {
        ...prevPayload,
        [`${apiCallerId}Status`]: 'failed',
        message: res.message,
        elemId: null,
      };
    });
  }
};

export const fetchCardDetails = async (props) => {
  const {
    dataObject,
    callType,
    requestKeys = {},
    apiCallerId,
  } = props;
  const {
    setFormSubmissionPayload,
    loggerApiCall,
  } = props.functionObject;
  const {
    journeyId,
    iformIntegrationUrls,
  } = dataObject;
  const requestPayload = getMetaData(requestKeys, props.dataObject);
  const requestOptions = postCallRequestOptions(journeyId, requestPayload);
  const checkValidLead = `${iformIntegrationUrls}/iForms/unsecure/lms-connector/card-details?page=${getCurrentPage()}`;
  const res = await responseBuilder(checkValidLead, requestOptions);
  if (callType === 'standAlone') {
    if (res.statusIndicator === 'T') {
      loggerApiCall('status=fetchValidSnRLeadSucess', 'info');
      setFormSubmissionPayload((prevPayload) => ({
        ...prevPayload,
        cardType: res.data.keyword,
        cardName: res.data.card_product_name,
      })
      );
    } else {
      loggerApiCall(`status=fetchValidSnRLeadFailed with statusCode=${res.status} message=${res.message}`, 'error');
      setFormSubmissionPayload((prevPayload) => ({
        ...prevPayload,
        [`${apiCallerId}StatusCode`]: res.status,
        [`${apiCallerId}Status`]: 'failed',
        message: res.message || 'We are unable to retrieve your application.',
        elemId: 'error',
      }));
    }
  }
};

/* eslint complexity: ["error", 25] -- need to increase complexity */
/* eslint-disable max-len -- need */
export const createClicCase = async (props) => {
  const {
    formSubmissionPayload,
    formContainer,
    memberInfo,
  } = props.dataObject;
  const {
    setFormSubmissionPayload,
    loggerApiCall,
    setIsFormSubmission,
  } = props.functionObject;
  const {
    callType,
    apiCallerId = 'createClicCase',
  } = props;

  setFormSubmissionPayload((prevPayload) => {
    const newPayload = {
      ...prevPayload,
      createClicCaseStatus: 'inProgress',
      elemId: null,
    };
    return newPayload;
  });

  let onSuccessNavigate = 'continue';
  if (formContainer.operations?.[apiCallerId]
    && Object.keys(formContainer.operations[apiCallerId])
      .includes('onSuccessNavigate')) {
    onSuccessNavigate = formContainer.operations[apiCallerId].onSuccessNavigate;
  }
  let onFailNavigate = 'error';
  if (formContainer.operations?.[apiCallerId]
    && Object.keys(formContainer.operations[apiCallerId])
      .includes('onFailNavigate')) {
    onFailNavigate = formContainer.operations[apiCallerId].onFailNavigate;
  }
  loggerApiCall('status=calledCreateClicCaseApi', 'info');
  /**
   * Decide if we have to add clicSubType for this form ->
   * if yes --> decide which clicSubType --> based on memberInfo
   */
  let clicSubType = null;
  if (formContainer.operations?.[apiCallerId]?.isSubType && memberInfo) {
    const lob = memberInfo.accountTypes?.lineOfBusinessType;
    const paymentType = memberInfo.accountTypes?.paymentType;

    if (lob === 'CompanyCard') {
      clicSubType = 'sbs';
    } else if (lob === 'ConsumerCard' && paymentType === 'Revolve') {
      clicSubType = 'lending';
    } else if ((lob === 'ConsumerCard' && paymentType === 'ChargeCard') || lob === 'CorporateCard') {
      clicSubType = 'corp';
    }
  }

  if (!formSubmissionPayload.clicCaseNumber
    || (formSubmissionPayload.clicCaseNumber && clicSubType && formSubmissionPayload.clicSubType !== clicSubType)) {
    let requestPayload = {
      ...formSubmissionPayload,
      inquiryDate: new Date().toISOString(),
    };

    if (formContainer?.operations?.[apiCallerId]?.requestKeys) {
      requestPayload = getMetaData(formContainer?.operations?.[apiCallerId]?.requestKeys, props.dataObject);
    }
    requestPayload = stringifyObjectValues(requestPayload);
    const {
      iformIntegrationUrls,
      cuid,
      journeyId,
    } = props.dataObject;
    const requestOptions = postCallRequestOptions(journeyId, requestPayload);
    let createClicCaseApi = `${iformIntegrationUrls}/iForms/${formContainer.pageType}/oneclic/create/request?cuid=${cuid}&page=${getCurrentPage()}`;
    if (clicSubType) createClicCaseApi += `&subType=${clicSubType}`;
    const res = await responseBuilder(createClicCaseApi, requestOptions);
    setIsFormSubmission(false);
    if (callType === 'standAlone') {
      if (res.statusIndicator === 'T') {
        loggerApiCall('status=createClicCaseApiCallSuccess', 'info');
        setFormSubmissionPayload((prevPayload) => {
          let newPayload = {
            ...prevPayload,
            clicCaseNumber: res.data.caseNumber,
            createClicCaseStatus: 'success',
            elemId: onSuccessNavigate,
          };
          if (clicSubType) {
            newPayload = {
              ...newPayload,
              clicSubType,
            };
          }
          return newPayload;
        });
      } else {
        loggerApiCall(
          `status=createClicCaseApiCallFailed errorMsg=${res.message} status=${res.statusCode}`,
          'error'
        );
        setFormSubmissionPayload((prevPayload) => {
          const newPayload = {
            ...prevPayload,
            createClicCaseStatus: 'failed',
            elemId: onFailNavigate,
          };
          return newPayload;
        });
      }
    } else {
      return res;
    }
  } else if (callType === 'standAlone') {
    loggerApiCall('status=clic case has already been generated', 'info');
    setFormSubmissionPayload((prevPayload) => ({
      ...prevPayload,
      createClicCaseStatus: 'success',
      elemId: onSuccessNavigate,
    }));
  }
  return null;
};
/* eslint-enable max-len -- need */

/* eslint complexity: ["error", 36] -- need to increase complexity */
export const arketeam = async (props) => {
  const {
    dataObject,
    callType,
    apiCallerId,
  } = props;
  const {
    setFormSubmissionPayload,
    loggerApiCall,
  } = props.functionObject;
  const {
    formContainer,
    iformIntegrationUrls,
    journeyId,
  } = dataObject;
  const addDataAs = formContainer.operations?.[apiCallerId]?.addDataAs || 'arketeamResponse';
  const requestKeys = dataObject.formSubmissionPayload.arketeamTaxCall
    ? formContainer?.operations?.[apiCallerId]?.requestKeys?.taxId || {}
    : formContainer?.operations?.[apiCallerId]?.requestKeys?.companyInfo || {};
  const requestPayload = getMetaData(requestKeys, props.dataObject);
  if (requestPayload.contextInformation) {
    requestPayload.contextInformation = JSON.stringify(requestPayload.contextInformation);
  }
  const payload = {
    head: {
      traceId: uuid(),
      span: 'iForm6513',
      journeyId,
    },
    body: {
      ...requestPayload,
    },
  };
  const requestOptions = {
    method: 'POST',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
    },
    body: encryptPayload(payload),
  };
  loggerApiCall(
    `status=arketeamApiCalled for caller -- ${apiCallerId}`,
    'info'
  );

  // Call Arketeam API
  const res = dataObject.formSubmissionPayload.arketeamTaxCall ? await responseBuilder(
    `${iformIntegrationUrls}/iForms/unsecure/api/v1/functions/readInboundAggregatedUserData/taxId`,
    requestOptions
  ) : await responseBuilder(
    `${iformIntegrationUrls}/iForms/unsecure/api/v1/functions/readInboundAggregatedUserData/companyInfo`,
    requestOptions
  );

  if (res.statusIndicator === 'T') {
    if (callType === 'standAlone') {
      const responseData = res.data || {};

      if (dataObject.formSubmissionPayload.arketeamTaxCall
        && responseData?.userInformation?.users[0]?.businessInformation) {
        const mappedResponse = {
          companyLegalName: responseData.userInformation.users[0].businessInformation.businessName || '',
          registeredOfficeAddress: responseData.userInformation.users[0].businessInformation.addresses[0].line1 || '',
          companyPostalCode: responseData.userInformation.users[0].businessInformation.addresses[0].postalCode || '',
          companyCity: responseData.userInformation.users[0].businessInformation.addresses[0].city || '',
          companyCountry: responseData.userInformation.users[0].businessInformation.addresses[0].country || '',
          business_address: responseData.userInformation.users[0].businessInformation.addresses[1].line1 || '',
          businessPostalCode: responseData.userInformation.users[0].businessInformation.addresses[1].postalCode || '',
          businessCity: responseData.userInformation.users[0].businessInformation.addresses[1].city || '',
          businessCountry: responseData.userInformation.users[0].businessInformation.addresses[1].country || '',
          dateOfIncorporation: responseData.userInformation.users[0].businessInformation.incorporationDate || '',
          siretNumber: responseData.userInformation.users[0].businessInformation.addresses[1].siret || '',
          sectorOfActivity: responseData.userInformation.users[0].businessInformation.industryCodes[1].description || '',
          legalRepresentativeHonorifics_1: responseData.userInformation.users[0].businessInformation.beneficialOwners[0].personalInformation.names[0].title || '',
          legalRepresentativeFirstName_1: responseData.userInformation.users[0].businessInformation.beneficialOwners[0].personalInformation.names[0].first || '',
          legalRepresentativeBirthName_1: responseData.userInformation.users[0].businessInformation.beneficialOwners[0].personalInformation.birthInformation.birthName || '',
          legalRepresentativeDateOfBirth_1: responseData.userInformation.users[0].businessInformation.beneficialOwners[0].personalInformation.birthInformation.dateOfBirth || '',
          legalRepresentativePlaceOfBirth_1: responseData.userInformation.users[0].businessInformation.beneficialOwners[0].personalInformation.birthInformation.region || '',
          legalRepresentativeNationality_1: responseData.userInformation.users[0].businessInformation.beneficialOwners[0].personalInformation.nationality || '',
          legalRepresentativeCountryOfBirth_1: responseData.userInformation.users[0].businessInformation.beneficialOwners[0].personalInformation.birthInformation.country || '',
          legalRepresentativeAddress_1: responseData.userInformation.users[0].businessInformation.beneficialOwners[0].personalInformation.addresses[0].line1 || '',
          legalRepresentativePostalCode_1: responseData.userInformation.users[0].businessInformation.beneficialOwners[0].personalInformation.addresses[0].postalCode || '',
          legalRepresentativeCity_1: responseData.userInformation.users[0].businessInformation.beneficialOwners[0].personalInformation.addresses[0].city || '',
          legalRepresentativeCountryOfResidence_1: responseData.userInformation.users[0].businessInformation.beneficialOwners[0].personalInformation.addresses[0].country || '',
          duCapital_1: responseData.userInformation.users[0].businessInformation.beneficialOwners[0].businessInformation.ownershipPercentage || '',
        };
        setFormSubmissionPayload((prev) => ({
          ...prev,
          ...mappedResponse,
          elemId: null,
        }));
      }

      setFormSubmissionPayload((prev) => ({
        ...prev,
        [dataObject.formSubmissionPayload.arketeamTaxCall ? `${addDataAs}_taxId` : `${addDataAs}_companyInfo`]: responseData?.userInformation,
        elemId: null,
      }));
      loggerApiCall(`status=arketeamSuccess for ${apiCallerId}`, 'info');
    }
  } else {
    setFormSubmissionPayload((prev) => ({
      ...prev,
      [`${apiCallerId}Message`]: res.message,
      elemId: 'error',
    }));
    loggerApiCall(
      `arketeam FAILED (no payload) with statusCode=${res.status} message=${res.message}`,
      'error'
    );
  }
  return null;
};

export const ibanVerification = async (props) => {
  const {
    dataObject,
    callType,
    apiCallerId,
  } = props;
  const {
    setFormSubmissionPayload,
    loggerApiCall,
  } = props.functionObject;
  const {
    formContainer,
    iformIntegrationUrls,
    journeyId,
    cuid,
  } = dataObject;
  const addDataAs = formContainer.operations?.[apiCallerId]?.addDataAs || 'ibanVerification';
  const responseConditions = formContainer.operations?.[apiCallerId]?.responseConditions;
  const requestKeys = formContainer?.operations?.[apiCallerId]?.requestKeys || {};
  const requestPayload = getMetaData(requestKeys, props.dataObject);
  const requestOptions = postCallRequestOptions(journeyId, requestPayload);
  loggerApiCall(
    `status=IBANVerificationApiCalled for caller -- ${apiCallerId}`,
    'info'
  );

  // Call IBAN Verification API
  const res = await responseBuilder(
    `${iformIntegrationUrls}/iForms/secure/ebim/bankVerification?cuid=${cuid}&page=${getCurrentPage()}`,
    requestOptions
  );
  if (res.statusIndicator === 'T') {
    if (callType === 'standAlone') {
      const message = res.data?.reasons?.reduce((msg, reason) => {
        if (msg === '') {
          msg += reason.message;
        } else {
          msg = `${msg} | ${reason.message}`;
        }
        return msg;
      }, '');
      const responseCodes = res.data?.reasons?.map((r) => r.code) || [];
      /* eslint-disable no-restricted-syntax -- need */
      for (const condition of responseConditions[res.data?.status]) {
        const updatedPayload = {
          [addDataAs]: res.data,
          [`${apiCallerId}Status`]: res.data?.status?.toLowerCase(),
          elemId: condition?.onFindNavigate,
        };
        if (message) {
          updatedPayload[`${apiCallerId}Message`] = message;
        }
        if (responseCodes.length > 0 && condition?.codes?.length > 0) {
          if (responseCodes.some((code) => condition?.codes?.includes(code))) {
            setFormSubmissionPayload((prev) => ({
              ...prev,
              ...updatedPayload,
            }));
            loggerApiCall(
              `IBANVerification FAILED for ${apiCallerId}`,
              'error'
            );
            break;
          }
        } else {
          setFormSubmissionPayload((prev) => ({
            ...prev,
            ...updatedPayload,
          }));
        }
      }
      /* eslint-enable no-restricted-syntax -- need */
    }
  } else {
    setFormSubmissionPayload((prev) => ({
      ...prev,
      [`${apiCallerId}Message`]: res.message,
      elemId: 'error',
    }));
    loggerApiCall(
      `IBANVerification FAILED (no payload) with statusCode=${res.status} message=${res.message}`,
      'error'
    );
  }
  return null;
};

export const aceVerification = async (props) => {
  const {
    callType,
    dataObject,
    apiCallerId,
  } = props;
  const {
    setFormSubmissionPayload,
    loggerApiCall,
  } = props.functionObject;
  const {
    iformIntegrationUrls,
    journeyId,
    formContainer,
    cuid,
  } = dataObject;
  const requestKeys = formContainer?.operations?.[apiCallerId]?.requestKeys || {};
  const requestPayload = getMetaData(requestKeys, props.dataObject);
  const onSuccessNavigate = formContainer?.operations?.[apiCallerId]?.onSuccessNavigate;
  const onFailureNavigate = formContainer?.operations?.[apiCallerId]?.onFailureNavigate;
  const onInvalidCaseNavigate = formContainer?.operations?.[apiCallerId]?.onInvalidCaseNavigate;
  const responseCodes = formContainer.operations?.[apiCallerId]?.responseCodes;
  const requestOptions = postCallRequestOptions(journeyId, requestPayload);
  const addDataAs = formContainer.operations?.[apiCallerId]?.addDataAs || 'tinVerification';
  loggerApiCall(`status=aceVerification called for caller -- ${apiCallerId}`, 'info');
  const res = await responseBuilder(
    `${iformIntegrationUrls}/iForms/${formContainer.pageType}/ace/tinVerification?cuid=${cuid}&page=${getCurrentPage()}`,
    requestOptions
  );

  if (callType === 'parallel') {
    return res;
  }
  if (callType === 'standAlone') {
    if (res.statusIndicator === 'T') {
      loggerApiCall(
        'status=aceVerification success', 'info'
      );
      const aceStatus = res.data?.awaitingDocument;
      setFormSubmissionPayload((prevPayload) => {
        const newPayload = {
          ...prevPayload,
          [addDataAs]: res,
          [`${apiCallerId}Status`]: aceStatus ? 'Success' : 'DocumentReceived',
          elemId: aceStatus ? onSuccessNavigate : onInvalidCaseNavigate,
        };
        return newPayload;
      });
    } else if (res.statusIndicator === 'F') {
      const isInvalidCode = responseCodes.includes(res.status);
      setFormSubmissionPayload((prev) => ({
        ...prev,
        [`${apiCallerId}Message`]: res.message,
        [`${apiCallerId}Status`]: 'Failed',
        elemId: isInvalidCode ? onInvalidCaseNavigate : onFailureNavigate,
      }));
      loggerApiCall(
        `status=aceVerification FAILED (no payload) with statusCode=${res.status} message=${res.message}`,
        'error'
      );
    }
  }
  return null;
};

export const c360Verification = async (props) => {
  const {
    callType,
    dataObject,
    apiCallerId,
  } = props;
  const {
    setFormSubmissionPayload,
    loggerApiCall,
  } = props.functionObject;
  const {
    iformIntegrationUrls,
    journeyId,
    formContainer,
    cuid,
  } = dataObject;
  const requestKeys = formContainer?.operations?.[apiCallerId]?.requestKeys || {};
  const requestPayload = getMetaData(requestKeys, props.dataObject);
  const onSuccessNavigate = formContainer?.operations?.[apiCallerId]?.onSuccessNavigate;
  const onFailureNavigate = formContainer?.operations?.[apiCallerId]?.onFailureNavigate;
  const requestOptions = postCallRequestOptions(journeyId, requestPayload);
  const addDataAs = formContainer.operations?.[apiCallerId]?.addDataAs || 'c360Verification';
  loggerApiCall(
    `status=c360Verification called for caller -- ${apiCallerId}`,
    'info'
  );
  const res = await responseBuilder(
    `${iformIntegrationUrls}/iForms/secure/c360/inquiry?cuid=${cuid}`,
    requestOptions
  );
  if (callType === 'parallel') {
    return res;
  }
  if (callType === 'standAlone') {
    if (res.statusIndicator === 'T') {
      loggerApiCall(
        'status=c360Verification success', 'info'
      );
      setFormSubmissionPayload((prevPayload) => {
        const newPayload = {
          ...prevPayload,
          [addDataAs]: res.data,
          elemId: onSuccessNavigate,
        };
        return newPayload;
      });
    } else {
      setFormSubmissionPayload((prev) => ({
        ...prev,
        [`${apiCallerId}Message`]: res.message,
        elemId: onFailureNavigate,
      }));
      loggerApiCall(
        `status=c360Verification FAILED (no payload) with statusCode=${res.status} message=${res.message}`,
        'error'
      );
    }
  }
  return null;
};
const triggerPostOperations = (rawResponse, postOperationsProps, responseObject) => {
  /* eslint-disable no-restricted-syntax -- need */

  const {
    postOperations,
    apiCallerId,
  } = postOperationsProps;

  for (const operation of postOperations) {
    const {
      type,
      compareWith,
      compareValue,
      respStatus,
      respAction,
      ignoreOtherActions,
    } = operation;
    let exitFromAfterActions = false;
    switch (type) {
      case 'compare':
        if (getVal(rawResponse, compareWith) === compareValue) {
          responseObject = {
            ...responseObject,
            [`${apiCallerId}Status`]: respStatus,
            elemId: respAction,
          };
          if (ignoreOtherActions) {
            exitFromAfterActions = true;
          }
        }
        break;
      default:
        break;
    }
    if (exitFromAfterActions) break;
  }
  /* eslint-enable no-restricted-syntax -- need */
  return responseObject;
};

export const triggerAPI = async (props) => {
  const {
    dataObject,
    functionObject,
    apiCallerId,
  } = props;

  const {
    journeyId,
    formContainer,
  } = dataObject;

  const {
    loggerApiCall,
    setFormSubmissionPayload,
  } = functionObject;

  const apiDetails = formContainer.operations?.[apiCallerId];
  const {
    addDataAs = null,
    onSuccessStatus,
    onFailStatus,
    onSuccessNavigate,
    onFailNavigate,
    onSuccessMessage,
    onFailMessage,
    requestKeys = {},
    stringsToReplaceInURL,
    additionalOperations = {},
  } = apiDetails;

  let {
    apiURL,
  } = apiDetails;

  const {
    onSuccessOperations = null,
    onFailOperations = null,
  } = additionalOperations;

  let requestOptions = {};
  if (apiDetails?.method === 'POST') {
    const requestPayload = getMetaData(requestKeys, dataObject);
    requestOptions = postCallRequestOptions(journeyId, requestPayload);
  } else {
    requestOptions = getCallRequestOptions(journeyId);
  }
  if (stringsToReplaceInURL) {
    stringsToReplaceInURL.forEach((replaceData) => {
      apiURL = apiURL.replace(replaceData.key, getVal(dataObject, replaceData.value));
    });
  }
  const res = await responseBuilder(apiURL, requestOptions); // calls and handles the api
  const isSuccess = res.statusIndicator === 'T';

  const apiStatus = isSuccess ? onSuccessStatus : onFailStatus;
  const defaultMessage = isSuccess ? onSuccessMessage : onFailMessage;
  const onNavigate = isSuccess ? onSuccessNavigate : onFailNavigate;
  const postOperations = isSuccess ? onSuccessOperations : onFailOperations;

  let apiResponseObject = {
    [`${apiCallerId}Status`]: apiStatus,
    [`${apiCallerId}StatusCode`]: res.status,
    [`${apiCallerId}Message`]: res.message || defaultMessage,
    elemId: onNavigate,
  };

  if (postOperations) {
    const postOperationsProps = {
      postOperations,
      apiCallerId,
    };
    apiResponseObject = triggerPostOperations(
      res.data,
      postOperationsProps,
      apiResponseObject
    );
  }

  if (res.statusIndicator === 'T') {
    loggerApiCall('status=triggerApiCallSuccess', 'info');
    if (addDataAs) {
      apiResponseObject = {
        ...apiResponseObject,
        [addDataAs]: res.data,
      };
    }
  } else if (res.statusIndicator === 'F') {
    loggerApiCall(`status=triggerApiCallFailed with statusCode=${res.status} message=${res.message}`, 'error');
  }

  setFormSubmissionPayload((prevPayload) => ({
    ...prevPayload,
    ...apiResponseObject,
  }));

  return res;
};
/* eslint-enable  import/no-cycle -- need */
